import { useState } from "react";
import { Plus, Minus } from "lucide-react";

function FAQ() {
  const faqs = [
    {
      question: "Who can join these courses?",
      answer:
        "Students, graduates, working professionals, freelancers, and entrepreneurs who want to build digital skills can join.",
    },
    {
      question: "Do I need any prior experience?",
      answer:
        "No. All our courses are beginner-friendly and designed with step-by-step learning.",
    },
    {
      question: "Will I work on live projects?",
      answer:
        "Yes. Every course includes practical assignments and real-world projects to build your portfolio.",
    },
    {
      question: "Will I receive a certificate?",
      answer:
        "Yes. Students receive a certificate upon successful completion of their course.",
    },
    {
      question: "Are online classes available?",
      answer:
        "Yes. We offer both online and offline learning options.",
    },
    {
      question: "Will you provide career support?",
      answer:
        "Absolutely! We help with resume building, portfolio development, interview preparation, and career guidance.",
    },
  ];

  const [active, setActive] = useState(null);

  const toggleFAQ = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">

        {/* Heading */}

        <div className="text-center mb-14">

          <span className="bg-blue-100 text-blue-700 px-5 py-2 rounded-full font-semibold">
            FAQs
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold mt-6">
            Frequently Asked
            <span className="text-blue-700"> Questions</span>
          </h2>

          <p className="mt-5 text-gray-600">
            Everything you need to know before enrolling.
          </p>

        </div>

        {/* Accordion */}

        <div className="space-y-5">

          {faqs.map((faq, index) => (

            <div
              key={index}
              className="bg-white rounded-2xl shadow-md overflow-hidden"
            >

              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center px-7 py-6 text-left"
              >

                <h3 className="font-semibold text-lg text-gray-900">
                  {faq.question}
                </h3>

                {active === index ? (
                  <Minus className="text-blue-700" />
                ) : (
                  <Plus className="text-blue-700" />
                )}

              </button>

              {active === index && (
                <div className="px-7 pb-6 text-gray-600 leading-7">
                  {faq.answer}
                </div>
              )}

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}

export default FAQ;